'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _commonRelativeBarrier = require('./commonRelativeBarrier');

var _commonRelativeBarrier2 = _interopRequireDefault(_commonRelativeBarrier);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (contract, lastTickQuote) {
    return (0, _commonRelativeBarrier2.default)(contract.barrier, contract.entry_spot, lastTickQuote);
};


//////////////////
// WEBPACK FOOTER
// ./~/binary-utils/lib/barrier/relativeBarrier.js
// module id = 17
// module chunks = 0